import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import MonitoringBadge from './MonitoringBadge';
import { LogOut, Menu, X, Lock, PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import ServiceGate from '../ServiceGate';
import { useNavAreas, useActiveIntoView, useSideCollapsed, LOGO } from './nav';
import { eur } from '../api';
import BackButton from './BackButton';

function Side({ user, onNavigate, onLogout, onToggle, collapsed }) {
  const navigate = useNavigate();
  const areas = useNavAreas();
  const navRef = useActiveIntoView();
  return (
    <div className="ex-side">
      <div className="ex-head">
        <img src={LOGO} alt="BOND" className="ex-logo" />
        {onToggle && <button className="ex-toggle" onClick={onToggle} title={collapsed ? 'Espandi menu' : 'Riduci menu'} aria-label={collapsed ? 'Espandi menu' : 'Riduci menu'} data-testid="portal-side-toggle">{collapsed ? <PanelLeftOpen size={17} /> : <PanelLeftClose size={17} />}</button>}
      </div>
      <nav ref={navRef} className="ex-nav side-scroll" data-testid="portal-nav-list">
        {areas.map((a) => (
          <React.Fragment key={a.id}>
            {a.label && <p className="nav-area" data-testid={`portal-area-${a.id}`}>{a.label}</p>}
            {a.sub && <p className="nav-sub" data-testid={`portal-sub-${a.id}`}>{a.sub}</p>}
            {a.items.map(({ to, icon: Icon, label, testid, key, end, locked }) => (
              <NavLink key={key} to={to} end={end} onClick={onNavigate} title={collapsed ? label : undefined} data-testid={`portal-nav-${testid}`} className={({ isActive }) => (isActive ? 'active' : '')}>
                <Icon size={17} className="shrink-0" /> <span className="flex-1">{label}</span>{testid === 'monitoring' && !locked && <MonitoringBadge />}{locked && <Lock size={12} className="shrink-0 opacity-60" data-testid={`portal-nav-locked-${testid}`} />}
              </NavLink>
            ))}
          </React.Fragment>
        ))}
      </nav>
      <button className="ex-balance" onClick={() => { onNavigate(); navigate('/portal/plafond'); }} data-testid="portal-header-balance">
        <small>Saldo plafond</small><b>{eur(user.wallet_cents)}</b>
      </button>
      <div className="ex-user">
        <p data-testid="portal-user-name">{user.name || user.email}</p>
        <small>{user.company_name || user.email}</small>
        <button onClick={onLogout} data-testid="portal-logout"><LogOut size={14} /> Esci</button>
      </div>
    </div>
  );
}

export default function ExecutiveShell({ user, onLogout, ctx }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const close = () => setOpen(false);
  const [collapsed, toggle] = useSideCollapsed();
  return (
    <div className="portal-root ex-root" data-theme-active="executive">
      <aside className={`ex-aside hidden lg:block ${collapsed ? 'ex-collapsed' : ''}`} data-testid="portal-side"><Side user={user} onNavigate={() => {}} onLogout={onLogout} onToggle={toggle} collapsed={collapsed} /></aside>
      {open && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={close} />
          <aside className="absolute left-0 top-0 bottom-0 w-72 bg-[#0E1A2E]" style={{ paddingTop: 'env(safe-area-inset-top)', paddingBottom: 'env(safe-area-inset-bottom)' }}><Side user={user} onNavigate={close} onLogout={onLogout} /></aside>
          <button onClick={close} aria-label="Chiudi menu" style={{ top: 'calc(.75rem + env(safe-area-inset-top))' }} className="absolute left-[19.5rem] w-10 h-10 grid place-items-center rounded-full bg-black/60 text-white" data-testid="portal-mobile-menu-close"><X size={20} /></button>
        </div>
      )}
      <div className="flex-1 min-w-0 flex flex-col">
        <header className="ex-mobilebar lg:hidden">
          <div className="flex items-center gap-2"><BackButton /><button onClick={() => setOpen(!open)} data-testid="portal-mobile-menu">{open ? <X /> : <Menu />}</button></div>
          <img src={LOGO} alt="BOND" />
          <button className="chip" onClick={() => navigate('/portal/plafond')} data-testid="portal-mobile-balance">{eur(user.wallet_cents)}</button>
        </header>
        <main className="flex-1 px-5 py-8 lg:px-12 lg:py-10 w-full portal-main-bg" style={{ paddingBottom: 'calc(2rem + env(safe-area-inset-bottom))' }}>
          <div className={collapsed ? 'max-w-[1900px]' : 'max-w-[1500px]'}><ServiceGate ctx={ctx} /></div>
        </main>
      </div>
    </div>
  );
}
